import React from "react";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { EditCustomColumnModalBase } from "./modules/EditCustomColumnModalBase/EditCustomColumnModalBase";
import { formatErrorMessage } from "schedule-v2/components/recorded-content/ExamCreation/modals/QuestionsModal/questionsModal.utils";
import { useNotifications } from "utils/hooks";
import { useCrmStore } from "features/Crm/store/useCrmStore";
import { CUSTOM_COLUMN_FORM_KEYS } from "../CustomColumnFormFields/constants/CustomColumnFormField.constants";
import { useUpdateCustomColumn } from "../CustomColumn/apis/editCustomColumn";
import { CUSTOM_COLUMN_DATA_TYPE } from "../CustomColumn/constants/CustomColumn.constants";

export const EditCustomColumnModal = ({ sectionName }) => {
  const { notify } = useNotifications();
  const activeCustomColumn = useCrmStore((state) => state.activeCustomColumn);

  const updateCustomColumn = useUpdateCustomColumn({ sectionName });

  const formatDefaultValue = (value, dataType) => {
    if (!value) return null;
    if (dataType === CUSTOM_COLUMN_DATA_TYPE.DATE) {
      return new Date(value);
    }
    if (dataType === CUSTOM_COLUMN_DATA_TYPE.MULTIPLE_SELECT) {
      return JSON.parse(value.replace(/'/g, '"'));
    }
    if (dataType === CUSTOM_COLUMN_DATA_TYPE.GENDER) {
      return Number(value);
    }
    return value;
  };

  const handleEditCustomColumn = (values) => {
    const { column_name, options, default_value } = values;

    const columnData = {
      custom_column_uuid: activeCustomColumn?.uuid,
      updated_values: {
        column_name,
        default_column_value: default_value,
        metadata: {
          options: options?.map((i) => i.option),
        },
      },
    };

    updateCustomColumn.mutate(columnData);
  };

  const initialValues = {
    [CUSTOM_COLUMN_FORM_KEYS.column_name.key]: activeCustomColumn?.column_name,
    [CUSTOM_COLUMN_FORM_KEYS.field_type.key]: activeCustomColumn?.data_type,
    [CUSTOM_COLUMN_FORM_KEYS.options.key]:
      activeCustomColumn?.metadata?.options?.map((option) => ({ option })),
    [CUSTOM_COLUMN_FORM_KEYS.default_value.key]: formatDefaultValue(
      activeCustomColumn?.default_column_value,
      activeCustomColumn?.data_type
    ),
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleEditCustomColumn}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({ handleSubmit, invalid, errors, values }) => {
        const handleFormSubmit = () => {
          if (invalid)
            formatErrorMessage(errors).forEach((error) =>
              notify(error, "error")
            );
          handleSubmit(values);
        };
        return (
          <form onSubmit={handleFormSubmit}>
            <EditCustomColumnModalBase
              handleSubmit={handleFormSubmit}
              sectionName={sectionName}
              submitting={updateCustomColumn.isLoading}
            />
          </form>
        );
      }}
    </Form>
  );
};
